export function normalizeAuditRow(row) {
  return {
    id: row.id,
    timestamp: new Date(row.timestamp),
    timestampRaw: row.timestamp,
    action: row.action,
    description: row.description,
    userId: row.userId,
    userName: row.userName,
    userEmail: row.userEmail,
    debugData: row.debugData,
  };
}

export function resolveUserDisplayName({ userName, userEmail, userId }) {
  return userName || userEmail || userId;
}
